// extracted by mini-css-extract-plugin
module.exports = {"content":"Content-module__content--27OZD","centered":"Content-module__centered--35GoB","marginTop":"Content-module__marginTop--13fnv"};